// extracted by mini-css-extract-plugin
export default {"socialLink":"SocialLink_socialLink__YmQ3M"};